import React from "react";
import PropTypes from "prop-types";

const ContentRenderer = ({ contentBody, contentElementType, className }) => {
	const ElementType = contentElementType || "div";

	return (
		<ElementType
			className={className}
			dangerouslySetInnerHTML={{ __html: contentBody }}
		/>
	);
};

ContentRenderer.propTypes = {
	contentBody: PropTypes.string,
	contentElementType: PropTypes.string,
	className: PropTypes.string
};

export default ContentRenderer;
